<template>
    <div class="addcoordinator">
        <h2>添加国内协调员</h2>
        <el-form label-position="left" label-width="80px" :model="formLabelAlign">
            <el-form-item label="姓名:">
                <el-input v-model="formLabelAlign.name" placeholder="请输入姓名"></el-input>
            </el-form-item>
            <el-form-item label="手机号:">
                <el-input v-model="formLabelAlign.mobileNo" placeholder="请输入手机号"></el-input>
            </el-form-item>
            <el-form-item label="证件号码:">
                <el-input v-model="formLabelAlign.nationalId" placeholder="请输入证件号码"></el-input>
            </el-form-item>
            <el-form-item label="邮箱:">
                <el-input v-model="formLabelAlign.email" placeholder="请输入邮箱"></el-input>
            </el-form-item>
            <el-form-item label="登录名:">
                <el-input v-model="formLabelAlign.passport" placeholder="请输入登录名"></el-input>
            </el-form-item>
            <el-form-item label="登录密码:">
                <el-input type="password" v-model="formLabelAlign.password" placeholder="请输入登录密码"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="submitForm">注册并添加</el-button>
            </el-form-item>
          </el-form>
    </div>
</template>

<script>
import {
		Message
  } from "element-ui";
  import {
		addSubUser
	} from '@/views/axios/api.js';
export default {
  data() {
    return {
      formLabelAlign: {
          name: '',
          mobileNo: '',
          nationalId: '',
          passport: '',
          password: '',
          email:''
      },
      token:this.$route.params.token || JSON.parse(window.localStorage.getItem("data")).data,
      typeId: this.$route.query.typeId
    };
  },
  components: {

  },
  methods: {
    submitForm() {
      var data={}
      if(this.formLabelAlign.name == ''){
        Message.error("姓名不能为空");
      }else if(this.formLabelAlign.mobileNo == ''){
         Message.error("手机号不能为空");
      }else if(this.formLabelAlign.nationalId == ''){
         Message.error("证件号码不能为空");
      }else if(this.formLabelAlign.passport == ''){
         Message.error("登录名不能为空");
      }else if(this.formLabelAlign.password == ''){
         Message.error("密码不能为空");
      }else if(this.formLabelAlign.email == ''){
         Message.error("邮箱不能为空");
      }else{
        // data = this.formLabelAlign;
        data = Object.assign(this.formLabelAlign,{token:this.token});
        addSubUser(data)
						.then(res => {
              if (res.data.code == 0) {
                this.$message.success('添加成功！')
                this.formLabelAlign.name='';
                this.formLabelAlign.mobileNo='';
                this.formLabelAlign.nationalId='';
                this.formLabelAlign.passport='';
                this.formLabelAlign.password=''
                this.formLabelAlign.email=''
              }else if(res.data.code == 105013){
                this.$message.error('用户名已占用')
              }else{
                this.$message.error(res.data.msg)
              }
						})
						.catch(err => {
							console.log(err)
						})
      }
    }
  },
  mounted() {
    window.localStorage.setItem(
      "case",
      JSON.stringify({
        case: "ComAwait"
      })
    );
  }
};
</script>

<style scoped>
.addcoordinator .el-form{
  width: 40%;
  margin-top: 20px;
  margin-left: 10%;
}
</style>



// WEBPACK FOOTER //
// src/components/cmd_center/star/addcoordinator.vue